// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyChBLMAtWfxzfL9pIFSz_QBfn1Ytoddou4",
  authDomain: "mreload-pay-557.firebaseapp.com",
  projectId: "mreload-pay-557",
  storageBucket: "mreload-pay-557.firebasestorage.app",
  messagingSenderId: "77519427153",
  appId: "1:77519427153:web:942d08ba472e9d3e4a0a70"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Auth, Firestore, and Storage
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

